// Direction of a piece of text (or HTML), from its first letter that has a strong direction:
// Hebrew/Arabic -> 'rtl', Latin etc. -> 'ltr'. Empty or neutral text (numbers, punctuation) -> null.
const RTL_CHAR = /[֐-ࣿיִ-﷿ﹰ-﻿]/;
const LTR_CHAR = /[A-Za-zÀ-ɏͰ-ϿЀ-ӿ]/;

export function textDirection(text: string): 'rtl' | 'ltr' | null {
  if (!text) return null;
  const plain = text.replace(/<[^>]*>/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ');
  for (const ch of plain) {
    if (RTL_CHAR.test(ch)) return 'rtl';
    if (LTR_CHAR.test(ch)) return 'ltr';
  }
  return null;
}
